import { Link } from 'react-router-dom';
import LegalDoc from '../components/LegalDoc';
import {
  HOSTING_DC_ADDRESS,
  HOSTING_NAME,
  OFERTA_PATH,
  OPERATOR_EMAIL,
  OPERATOR_INN,
  OPERATOR_NAME,
  OPERATOR_OGRNIP,
  OPERATOR_PHONE,
  OPERATOR_REGION,
  POLICY_DATE,
  PROCESSING_START_DATE,
  SITES_LABEL,
} from '../legal/operator';

export default function ConsentPage() {
  return (
    <LegalDoc title="Согласие на обработку персональных данных">
      <p>
        Настоящее согласие — отдельный документ. Оно не является частью{' '}
        <Link to={OFERTA_PATH}>договора-оферты</Link>
        . Текст политики:{' '}
        <Link to="/privacy">Политика обработки персональных данных</Link>.
      </p>
      <p>
        Редакция: {POLICY_DATE}. Обработка с согласия начинается не ранее{' '}
        {PROCESSING_START_DATE}.
      </p>

      <h2>1. Кто даёт согласие</h2>
      <p>
        Субъект персональных данных — клиент (ученик или законный представитель)
        либо иное лицо, которое ставит отметку в форме регистрации на Сайте (
        {SITES_LABEL}) и передаёт свои данные. Субъект идентифицируется по
        сведениям, указанным в форме (имя, логин, email).
      </p>
      <p>
        Если субъекту нет 18 лет, согласие даёт законный представитель либо субъект
        подтверждает, что представитель согласен на использование Сайта.
      </p>

      <h2>2. Оператор</h2>
      <ul>
        <li>{OPERATOR_NAME}</li>
        <li>ИНН: {OPERATOR_INN}</li>
        <li>ОГРНИП: {OPERATOR_OGRNIP}</li>
        <li>Регион регистрации: {OPERATOR_REGION}</li>
        <li>
          Email:{' '}
          <a href={`mailto:${OPERATOR_EMAIL}`}>{OPERATOR_EMAIL}</a>
        </li>
        <li>Телефон: {OPERATOR_PHONE}</li>
      </ul>

      <h2>3. Цели</h2>
      <p>
        Подготовка, заключение и исполнение гражданско-правового договора на
        оказание образовательных услуг через Сайт, а именно:
      </p>
      <ol>
        <li>Создание и ведение учётной записи, вход на Сайт.</li>
        <li>
          Оказание образовательных услуг: занятия, задания, проверка решений, журнал,
          отображение прогресса преподавателю и родителю (если связь настроена).
        </li>
        <li>
          Анкета ученика (цели подготовки, нагрузка, финансовые возможности) — чтобы
          согласовать формат занятий.
        </li>
        <li>Приём оплаты и направление чека.</li>
        <li>Связь по выбранному каналу (email, «Макс», телефон).</li>
        <li>Безопасность и работоспособность Сайта.</li>
      </ol>

      <h2>4. Перечень данных</h2>
      <p>
        В том числе фамилия, имя, отчество и адрес электронной почты. Также
        обрабатываются: логин, хеш пароля, канал связи, сведения профиля (телефон,
        город, школа, класс, роль, аватар), ответы анкеты, код и
        результаты решений, данные о присутствии на занятии, журнал занятий,
        сведения об оплате, технические данные (cookie сессии, IP в журналах сервера).
      </p>

      <h2>5. Действия и способы</h2>
      <p>
        Сбор, запись, систематизация, накопление, хранение, уточнение (обновление,
        изменение), извлечение, использование, передача (предоставление) указанным в
        Политике получателям, блокирование, удаление, уничтожение. Обезличивание
        не применяется. Обработка — автоматизированная, с передачей по сети
        Интернет, с использованием Сайта и базы данных на территории РФ (
        {HOSTING_NAME}, {HOSTING_DC_ADDRESS}).
      </p>
      <p>
        Получатели в объёме, нужном для цели: хостинг {HOSTING_NAME}, Озон Пай,
        почтовый сервис, «Макс» или ВКонтакте — если вы указали этот канал.
      </p>

      <h2>6. Срок и отзыв</h2>
      <p>
        Согласие действует с момента отметки в форме до отзыва либо до достижения
        целей обработки (удаление учётной записи), если закон не требует хранить
        данные дольше (расчёты).
      </p>
      <p>
        Отозвать согласие и потребовать удаление можно письмом на{' '}
        <a href={`mailto:${OPERATOR_EMAIL}`}>{OPERATOR_EMAIL}</a>
        . Отзыв не затрагивает обработку, которая уже выполнена, и обработку,
        необходимую для исполнения договора и закона.
      </p>

      <h2>7. Добровольность</h2>
      <p>
        Согласие даётся свободно, своей волей и в своём интересе. Без согласия
        регистрация на Сайте недоступна: услуги оказываются через личный кабинет.
      </p>
    </LegalDoc>
  );
}
